import React from 'react';
import { Box, Typography, TextField, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const EditableAccordionHeader = ({
  sectionKey,
  heading,
  isEditing,
  tempValue,
  setTempValue,
  onEdit,
  onSave,
  onCancel
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSave(sectionKey);
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1} className="editable-accordion-header">
      {isEditing ? (
        <>
          <TextField
            value={tempValue}
            onChange={(e) => setTempValue(e.target.value)}
            onKeyPress={handleKeyPress}
            onClick={(e) => e.stopPropagation()}
            variant="outlined"
            size="small"
            autoFocus
            sx={{
              '& .MuiOutlinedInput-root': {
                fontSize: '1.25rem',
                fontWeight: 600,
                color: '#2E2E3A',
                '& fieldset': {
                  borderColor: '#e0e0e0',
                },
                '&:hover fieldset': {
                  borderColor: '#2196f3',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#2196f3',
                }
              }
            }}
          />
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onSave(sectionKey);
            }}
            sx={{ color: '#4caf50' }}
          >
            <CheckIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
            sx={{ color: '#f44336' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      ) : (
        <>
          <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
            {heading}
          </Typography>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(sectionKey);
            }}
            sx={{ 
              color: '#666',
              '&:hover': {
                color: '#2196f3',
                backgroundColor: 'rgba(33, 150, 243, 0.04)'
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default EditableAccordionHeader;